function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "CR",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Table-View-|-Survey/year",
  transform: "translate(-1023.000000, -165.000000)",
  fill: "#CD7371"
}, /*#__PURE__*/React.createElement("g", {
  id: "sidebar",
  transform: "translate(1000.000000, 146.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "modify"
}, /*#__PURE__*/React.createElement("path", {
  d: "M36,19 C43.1797017,19 49,24.8202983 49,32 C49,39.1797017 43.1797017,45 36,45 C28.8202983,45 23,39.1797017 23,32 C23,24.8202983 28.8202983,19 36,19 Z M42,36.00125 L30,36.00125 L30,38.00125 L42,38.00125 L42,36.00125 Z M37,27.62625 L32,32.62625 L32,34.50125 L33.875,34.50125 L38.875,29.50125 L37,27.62625 Z M39.1158848,26.0884722 C38.9214815,25.9536574 38.6533333,25.9729167 38.48,26.14625 L38.48,26.14625 L37.5,27.12625 L39.375,29.00125 L40.355,28.02125 L40.4127778,27.9521348 C40.5475926,27.7577315 40.5283333,27.4895833 40.355,27.31625 L40.355,27.31625 L39.185,26.14625 Z"
})))));

var SvgModify = function SvgModify(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgModify, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/modify.042f84ce.svg";
export { ForwardRef as ReactComponent };